import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import SectionHeading from '../common/SectionHeading';
import Button from '../common/Button';

const SectionContainer = styled.section`
  background-color: #121212;
  color: #FFFFFF;
  padding: 100px 0;
  
  @media (max-width: 768px) {
    padding: 80px 0;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  margin: 60px 0;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 60px;
  }
`;

const Step = styled(motion.div)`
  flex: 1;
  text-align: center;
  position: relative;
`;

const StepNumber = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #2196F3;
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  z-index: 2;
  position: relative;
`;

const Connector = styled.div`
  position: absolute;
  top: 30px;
  right: -20px;
  width: calc(100% - 60px);
  height: 2px;
  background-color: #2196F3;
  z-index: 1;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const StepTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 16px;
  color: #FFFFFF;
`;

const StepDescription = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  line-height: 1.6;
  color: #E0E0E0;
`;

const StepIcon = styled.div`
  font-size: 48px;
  margin-bottom: 24px;
  color: #2196F3;
`;

// eslint-disable-next-line no-unused-vars
const Animation = styled.div`
  background-color: #1E1E1E;
  border-radius: 12px;
  padding: 32px;
  margin: 40px 0;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    max-width: 100%;
    border-radius: 8px;
  }
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 40px;
`;

const HowItWorksSection = () => {
  const steps = [
    {
      title: "Research",
      description: "Tell CarConsul what you're looking for in a car",
      icon: "🔍",
    },
    {
      title: "Discover",
      description: "Get AI-powered recommendations based on your needs",
      icon: "💡",
    },
    {
      title: "Decide",
      description: "Compare options, check for issues, and negotiate confidently",
      icon: "✅",
    }
  ];

  return (
    <SectionContainer>
      <Content>
        <SectionHeading 
          title="Car Buying Simplified" 
          subtitle="Our AI assistant guides you through every step of the car buying process"
        />
        
        <StepsContainer>
          {steps.map((step, index) => (
            <Step
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <StepNumber>{index + 1}</StepNumber>
              {index < steps.length - 1 && <Connector />}
              <StepIcon>{step.icon}</StepIcon>
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </Step>
          ))}
        </StepsContainer>

        
        <ButtonContainer>
          <Button 
            variant="secondary" 
            size="large"
            id="how-it-works-cta-button"
            sectionName="how-it-works"
            onClick={() => window.location.href = 'https://app.carconsul.com'}>
          >
            Start Your Research
          </Button>
        </ButtonContainer>
      </Content>
    </SectionContainer>
  );
};

export default HowItWorksSection;
